__turbopack_context__.v({
  "className": "caveat_8bc06705-module__UjV1yW__className",
});
